import React from "react"
import { Box, Button, Typography } from "@mui/material"
import { GenericCircleIcon } from "../../../generic/GenericCircleIcon"
import { useTheme } from "@emotion/react"
import { CheckCircle } from "@phosphor-icons/react"
import { NeedHelp } from "../../topbar/generic/GenericDialogFooter"

export const OndatoVerification = ({ handleCloseDialog }) => {
  const theme = useTheme();
  return (
    <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} sx={{ padding: '32px 14px' }} gap={2.5}>
      <GenericCircleIcon>
        <CheckCircle size={80} color={theme.palette.primary.main} weight="light" />
      </GenericCircleIcon>
      <Box textAlign={"center"} display={"flex"} flexDirection={"column"} gap={1}>
        <Typography variant="h5" color="primary" fontWeight={700}>Profile Submitted</Typography>
        <Typography variant="subtitle1" textAlign={'center'}>Your profile has been submitted for review and will be processed in 1-3 days. Once processed, you will have full access to WannaCollab. Thank you for your interest on being part of our community!</Typography>
      </Box>
      <Button variant="contained" sx={{ color: '#FFF', width: { xs: '100%', sm: '250px ' } }} onClick={() => handleCloseDialog()}>Close</Button>
      <NeedHelp />
    </Box>
  )
}